<template>
  <div>
    <!-- Overlay for mobile -->
    <div
      v-if="showSidebar && isMobile"
      class="sidebar-overlay"
      @click="closeSidebar"
    ></div>

    <!-- Sidebar -->
    <div
      class="sidebar"
      :class="{
        'sidebar-open': showSidebar,
        'sidebar-mobile': isMobile,
        'sidebar-desktop': !isMobile,
      }"
    >
      <!-- Logo -->
      <div class="sidebar-logo">
        <a href="https://console.isilive.ca" target="_blank">
          <img src="https://video.isilive.ca/cdn/isilive_logo.png" alt="Logo" />
          <span>Admin Console</span>
        </a>
      </div>

      <!-- Navigation -->
      <nav class="sidebar-nav">
        <!-- Section 1: Core Management -->
        <div class="nav-section">
          <router-link to="/dashboard" class="nav-item" @click="handleNavClick">
            <v-icon>mdi-view-dashboard</v-icon>
            <span>Dashboard</span>
          </router-link>

          <router-link
            v-if="isAdmin"
            to="/streams"
            class="nav-item"
            @click="handleNavClick"
          >
            <v-icon>mdi-video</v-icon>
            <span>Live Streams</span>
          </router-link>

          <router-link
            v-if="isAdmin"
            to="/videos"
            class="nav-item"
            @click="handleNavClick"
          >
            <v-icon>mdi-video-box</v-icon>
            <span>VOD Assets</span>
          </router-link>

          <router-link
            v-if="isAdmin"
            to="/client-accounts"
            class="nav-item"
            @click="handleNavClick"
          >
            <v-icon>mdi-account-multiple</v-icon>
            <span>Client Accounts</span>
          </router-link>

          <router-link
            v-if="isAdmin"
            to="/findedituser"
            class="nav-item"
            @click="handleNavClick"
          >
            <v-icon>mdi-account-group</v-icon>
            <span>Users</span>
          </router-link>
        </div>

        <!-- Section 2: Tools -->
        <div class="nav-section">
          <router-link
            v-if="isAdmin"
            to="/shorturl"
            class="nav-item"
            @click="handleNavClick"
          >
            <v-icon>mdi-link-variant</v-icon>
            <span>URL Shortener</span>
          </router-link>

          <router-link
            v-if="isAdmin"
            to="/quickshare"
            class="nav-item"
            @click="handleNavClick"
          >
            <v-icon>mdi-share-variant</v-icon>
            <span>Quick Share</span>
          </router-link>
        </div>

        <!-- Section 3: Administration -->
        <div class="nav-section">
          <router-link
            v-if="isAdmin"
            to="/encode_cluster"
            class="nav-item"
            @click="handleNavClick"
          >
            <v-icon>mdi-server</v-icon>
            <span>Encoding Cluster</span>
          </router-link>

          <router-link
            v-if="isAdmin"
            to="/streaming_cluster"
            class="nav-item"
            @click="handleNavClick"
          >
            <v-icon>mdi-access-point-network</v-icon>
            <span>Streaming Cluster</span>
          </router-link>

          <router-link
            v-if="isAdmin"
            to="/platform-settings"
            class="nav-item"
            @click="handleNavClick"
          >
            <v-icon>mdi-alert-octagon</v-icon>
            <span>Platform Settings</span>
          </router-link>
        </div>

        <!-- Section 4: Admin Docs -->
        <div v-if="isAdmin" class="nav-section">
          <router-link
            to="/admin-docs/assistant"
            class="nav-item"
            @click="handleNavClick"
          >
            <v-icon>mdi-robot-outline</v-icon>
            <span>AI Assistant</span>
          </router-link>

          <router-link
            to="/admin-docs/docs"
            class="nav-item"
            @click="handleNavClick"
          >
            <v-icon>mdi-book-open-variant</v-icon>
            <span>Documentation</span>
          </router-link>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  name: "SimpleSidebar",
  data() {
    return {
      showSidebar: false,
      isMobile: false,
    };
  },
  computed: {
    isAdmin() {
      return this.$store.state.user_data.is_admin;
    },
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener("resize", this.checkScreenSize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkScreenSize);
  },
  methods: {
    checkScreenSize() {
      this.isMobile = window.innerWidth < 960;
      // Set initial state: visible on desktop, hidden on mobile
      this.showSidebar = !this.isMobile;
    },
    toggleSidebar() {
      this.showSidebar = !this.showSidebar;
    },
    closeSidebar() {
      this.showSidebar = false;
    },
    handleNavClick() {
      // Close sidebar on mobile when nav item is clicked
      if (this.isMobile) {
        this.closeSidebar();
      }
    },
  },
};
</script>

<style scoped>
.sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 998;
}

.sidebar {
  width: 260px;
  background: rgba(27, 27, 27, 0.87);
  color: white;
  overflow-y: auto;
  transition: all 0.3s ease;
}

.sidebar-desktop {
  position: static;
  transform: none;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  height: 100%;
  flex-shrink: 0;
}

.sidebar-desktop:not(.sidebar-open) {
  width: 0;
  overflow: hidden;
}

.sidebar-mobile {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  height: 100vh;
  transform: translateX(-100%);
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.3);
}

.sidebar-mobile.sidebar-open {
  transform: translateX(0);
}

.sidebar-logo {
  padding: 20px 15px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.sidebar-logo a {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: white;
}

.sidebar-logo img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 12px;
}

.sidebar-logo span {
  font-size: 16px;
  font-weight: 400;
  text-transform: uppercase;
}

.sidebar-nav {
  padding: 20px 0;
  flex: 1;
}

.nav-section {
  margin-bottom: 20px;
  padding-bottom: 20px;
}

.nav-section:not(:last-child) {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.nav-item {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: all 0.3s ease;
  margin: 0 15px;
  border-radius: 4px;
}

.nav-item:hover {
  background: rgba(255, 255, 255, 0.1);
  color: white;
}

.nav-item.router-link-active {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}

.nav-item .v-icon {
  margin-right: 16px;
  font-size: 20px;
}

.nav-item span {
  font-size: 14px;
  font-weight: 300;
}

/* Adjust main content when sidebar is open on desktop */
.main-content-shifted {
  margin-left: 260px;
}

@media (max-width: 959px) {
  .sidebar {
    position: fixed;
  }
}
</style>
